import { Navigate, useLocation } from 'react-router-dom';

import { useSessionStore } from './session';

export default function RequireAuth({ children }: { children: React.ReactNode }) {
  const token = useSessionStore((s) => s.accessToken);
  const user = useSessionStore((s) => s.user);
  const location = useLocation();
  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  // Hard gate: admin-created users must rotate their password before they can
  // use anything else. The change-password page is itself wrapped in
  // RequireAuth, so we have to whitelist it here to avoid a redirect loop.
  if (user?.must_change_password && location.pathname !== '/app/change-password') {
    return <Navigate to="/app/change-password" replace />;
  }
  return <>{children}</>;
}
